import React from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import Chart from "react-apexcharts";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  labelChart: {
    color: "#707070",
    fontSize: 20,
    lineHeight: 1.35,
  },
}));

const options = {
  chart: {
    height: 350,
    type: "radialBar",
  },
  plotOptions: {
    radialBar: {
      startAngle: -90,
      endAngle: 90,
      dataLabels: {
        name: {
          show: false,
        },
        value: {
          fontFamily: "Roboto",
          offsetY: 20,
          fontSize: "40px",
          color: "#0a1832",
        },
      },
    },
  },
  fill: {
    colors: ["#1290d5"],
  },
};

export const ResultAssessmentsChart = ({ total, label }) => {
  const classes = useStyles();

  return (
    <>
      <Chart
        options={{ ...options }}
        series={[total]}
        type="radialBar"
        height={250}
      />
      <Typography className={classes.labelChart} align="center">
        {label}
      </Typography>
    </>
  );
};

ResultAssessmentsChart.propTypes = {
  total: PropTypes.number,
  label: PropTypes.string,
};

ResultAssessmentsChart.defaultProps = {
  total: 0,
  label: "",
};
